import { Alert, Button, Group, Modal, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconAlertTriangle, IconChevronRight } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import type { ChartReadinessGap } from '../utils/chartReadinessGaps';
import { dismissChartReadiness } from '../utils/chartReadinessGaps';

export interface ClientChartReadinessModalProps {
  opened: boolean;
  clientId: string;
  gaps: ChartReadinessGap[];
  onClose: () => void;
}

export function ClientChartReadinessModal({
  opened,
  clientId,
  gaps,
  onClose,
}: ClientChartReadinessModalProps): JSX.Element {
  const handleDismiss = (): void => {
    dismissChartReadiness(clientId);
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleDismiss}
      title="Client account needs attention"
      size="md"
      centered
      styles={{ content: { border: '1px solid #9CA3AF' } }}
    >
      <Stack gap="md">
        <Alert variant="light" color="yellow" icon={<IconAlertTriangle size={18} />}>
          Complete the items below before the next session when possible.
        </Alert>
        <Stack gap="md">
          {gaps.map((gap) => (
            <Group key={gap.kind} align="flex-start" gap="sm" wrap="nowrap">
              <ThemeIcon color="gold" size={22} radius="xl" variant="light" mt={2}>
                <IconChevronRight size={14} />
              </ThemeIcon>
              <Stack gap={4} style={{ flex: 1, minWidth: 0 }}>
                <Text fw={600}>{gap.title}</Text>
                <Text size="sm" c="dimmed">
                  {gap.description}
                </Text>
                <Text
                  component={Link}
                  to={gap.href}
                  size="sm"
                  c="gold.7"
                  fw={500}
                  onClick={handleDismiss}
                >
                  Go to section
                </Text>
              </Stack>
            </Group>
          ))}
        </Stack>
        <Group justify="flex-end">
          <Button variant="outline" onClick={handleDismiss}>
            Dismiss for now
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
